<template>
  <b-modal
    id="template-message-modal"
    ref="templateMessageModal"
    :title="`${update ? 'Update': 'Create'} Template Message`"
    hide-footer
    size="md"
    @hidden="clear">
    <label class="col-form-label pt-0">
      <span>Keyword</span>
      <icon
        v-b-tooltip="getTooltipConfig('Tooltip')"
        name="info-circle"
        class="info-label"/>
    </label>
    <b-form-group>
      <b-input
        v-model="keyword"
        :disabled="!!keywordp.length"
        placeholder="order_notification"
        @keydown.native="preventSpace"/>
      <span
        v-if="validationErrors.keyword"
        class="validation-error clearfix">
        {{ validationErrors.keyword }}
      </span>
    </b-form-group>
    <label class="col-form-label pt-0">
      <span>Select Language</span>
      <icon
        v-b-tooltip="getTooltipConfig('Tooltip')"
        name="info-circle"
        class="info-label"/>
    </label>
    <b-form-group>
      <b-select
        v-model="language"
        placeholder="Select Language">
        <option
          v-for="lang in languageList"
          :key="lang.code"
          :value="lang.code">{{ lang.name }} ({{ lang.local_name }})</option>
      </b-select>
      <span
        v-if="validationErrors.language"
        class="validation-error">{{ validationErrors.language }}</span>
    </b-form-group>
    <label class="col-form-label pt-0">
      <span>Translation Message</span>
      <icon
        v-b-tooltip="getTooltipConfig('Tooltip')"
        name="info-circle"
        class="info-label"/>
    </label>
    <b-form-group>
      <MessageTextArea
        ref="messageArea"
        :enter-submit="false"
        :native-tags="true"
        :custom-tags="true"
        position="top"
        placeholder="Add Message"/>
      <span
        v-if="validationErrors.text"
        class="validation-error">{{ validationErrors.text }}</span>
    </b-form-group>
    <span
      v-if="errorMessage"
      class="error-message">
      {{ errorMessage }}
    </span>
    <b-button
      :class="{loading: saving}"
      :disabled="saving"
      class="btn-round btn-block mt-4 mb-4"
      @click="saveMessage">
      <span v-if="!saving">Save</span>
      <div class="loader"><div class="loading-circle"/></div>
    </b-button>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import setValidationErrors from '@/helpers/validationErrors';
import languageList from '@/helpers/lists/languages';
import MessageTextArea from '@/components/common/MessageTextArea';

export default {
  name: 'TemplateMessageModal',
  components: {
    MessageTextArea,
  },
  props: {
    messagep: {
      type: Object,
      default: () => {},
    },
    keywordp: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      languageList,
      keyword: '',
      language: 'en',
      text: '',
      update: false,
      saving: false,
      errorMessage: '',
      validationErrors: {},
    };
  },
  computed: {
    ...mapGetters({
      templateMessageCreated: 'notification/templateMessageCreated',
      templateMessageUpdated: 'notification/templateMessageUpdated',
      apiError: 'notification/apiError',
    }),
  },
  watch: {
    templateMessageCreated(saved) {
      if (saved) {
        this.saving = false;
        this.$emit('saved', this.keyword);
        this.hide();
      }
    },
    templateMessageUpdated(saved) {
      if (saved) {
        this.saving = false;
        this.$emit('saved', this.keyword);
        this.hide();
      }
    },
    apiError(error) {
      this.saving = false;
      if (error.status === 422) {
        this.validationErrors = setValidationErrors(error.data.errors);
      } else {
        this.errorMessage = error.data.message;
      }
    },
  },
  methods: {
    ...mapActions({
      createTemplateMessage: 'notification/createTemplateMessage',
      updateTemplateMessage: 'notification/updateTemplateMessage',
    }),
    getTooltipConfig(text) {
      return {
        title: text,
        placement: 'right',
        animation: false,
        offset: '0, 5px',
      };
    },
    setMessageData() {
      this.keyword = this.keywordp;
      // if (!this.$lodash.isEmpty(this.messagep)) {
      //   this.update = true;
      //   this.keyword = this.messagep.keyword;
      //   this.$refs.messageArea.setText(this.messagep.keyword.text);
      // } else {
      //   this.clear();
      // }
    },
    preventSpace(e) {
      if (e.which === 32) {
        e.preventDefault();
      }
    },
    saveMessage() {
      this.saving = true;
      this.errorMessage = '';
      this.validationErrors = {};
      const data = {
        keyword: this.keyword,
        language: this.language,
        text: this.$refs.messageArea.getText(),
      };

      if (this.update) {
        this.updateTemplateMessage({
          merchant_id: this.$route.params.merchant_id,
          template_id: this.messagep.id,
          data,
        });
      } else {
        this.createTemplateMessage({
          merchant_id: this.$route.params.merchant_id,
          data,
        });
      }
    },
    show() {
      this.setMessageData();
      this.$refs.templateMessageModal.show();
    },
    clear() {
      Object.assign(this.$data, this.$options.data.apply(this));
    },
    hide() {
      this.$refs.templateMessageModal.hide();
      this.$refs.messageArea.setText('');
    },
  },
};
</script>
